<template>
<v-container fluid fill-height>
    <v-layout wrap align-center justify-center>
        <img src="../assets/logo.png" width="650" class="px-4">

        <v-flex xs12 sm6 md4>
            <v-card :loading="load" class="elevation-1">
                <!-- <v-toolbar dark color="toolbar">
                    <v-toolbar-title>Estoque SM</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <v-btn slot="activator" :href="source" icon large target="_blank">
                            <v-icon large>sort</v-icon>
                        </v-btn>
                        <span>Sobre</span>
                    </v-tooltip>
                </v-toolbar>-->
                <v-card-text>
                    <v-form>
                        <v-text-field prepend-icon="person" name="username" v-model="user.username" label="Login" type="text"></v-text-field>
                        <v-text-field v-model="password" prepend-icon="lock" name="password" label="Senha" type="password" @keyup.enter="logar2()"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="logar2" :loading="load" dark color="primary">Login</v-btn>
                </v-card-actions>
            </v-card>
            <v-alert class="mt-1" dark :value="alert" color="error">{{msg}}</v-alert>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
// import service from './../services/userservice'
const sha1 = require('js-sha1')

export default {
  data: () => ({
    drawer: null,
    user: {},
    load: false,
    password: '',
    logado: {},
    progress: false,
    alert: false,
    msg: ''
  }),
  props: {
    source: String
  },
  watch: {
    msg (val) {
      val && setTimeout(() => { this.alert = false }, 5000)
    }
  },
  methods: {
    // logar () {
    //   this.alert = false
    //   this.msg = ''
    //   if (this.user.username !== '' && this.password !== '') {
    //     this.load = true
    //     service.login({ username: this.user.username, password: sha1(this.password) }).then(r => {
    //       if (r.status === 200) {
    //         this.$cookies.set('token', r.data.token)
    //         this.$router.push('/')
    //       } else {
    //         this.alert = true
    //         this.msg = r.data.msg
    //       }
    //     }).finally(() => {
    //       this.load = false
    //     })
    //   } else {
    //     this.alert = true
    //     this.msg = 'Por favor preencher os campos'
    //   }
    // },
    logar2 () {
      this.alert = false
      this.msg = ''
      if (this.user.username !== '' && this.password !== '') {
        this.load = true
        this.$store
          .dispatch('Login', { username: this.user.username, cred: sha1(this.password) })
          .then(r => {
            if (r.status === 1) {
              this.$router.push('/')
            } else {
              this.alert = true
              this.msg = 'Por favor verifique o login e senha'
            }
          }).finally(() => {
            this.load = false
          })
      } else {
        this.alert = true
        this.msg = 'Por favor preencher os campos'
      }
    }
  }
}
</script>
